export default __webpack_public_path__ + "static/1612-d94f1ea7350de84871eef47cafbd3ac0.gif";